module.exports = __webpack_public_path__ + "img/cardImg3.0ffb4076.png";